import React from "react";
import { CellContext } from "@tanstack/react-table";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";

export const SupportRequestTypeCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue<string>()
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (val: string) => {
        setValue(val);
        table.options.meta?.updateData(index, id, val)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className="w-full min-h-8">
                        {value ? value : "Resource"}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem className="w-full min-h-8"
                        onClick={() => {
                            onBlur("Resource");
                        }} >
                            <div className="w-full text-center">Resource</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        className="w-full min-h-8"
                        onClick={() => {
                            onBlur("Financial");
                        }}
                    >
                        <div className="w-full text-center">Financial</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        className="w-full min-h-8"
                        onClick={() => {
                            onBlur("Other");
                        }}
                    >
                        <div className="w-full text-center">Other</div>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <>{value ? value : "Resource"}</>
};